import { Component, ReactNode } from "react";
export default class ContactPage extends Component<any, any> {

    render() {
        return (
          <>
            <div className='text-red-500'>elo</div>
          </>  
        );
    }
}